import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuthStore } from '../../../store/authStore'

/**
 * Refreshes permissions on route navigation.
 * Deduplication of concurrent calls is handled inside loadUserPermissions itself
 * (permissionsLoading guard + PERMISSION_THROTTLE_MS).
 */
export const usePermissionGuard = () => {
  const location = useLocation()
  const loadUserPermissions = useAuthStore((state) => state.loadUserPermissions)
  const user = useAuthStore((state) => state.user)
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const isMounted = useRef(false)

  // Skip the very first render — initializePermissions in App.tsx covers initial load.
  // Only fire on subsequent route changes to avoid a redundant call on mount.
  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true
      return
    }
    if (user && isAuthenticated) {
      loadUserPermissions()
    }
  }, [location.pathname]) // eslint-disable-line react-hooks/exhaustive-deps
}

export default usePermissionGuard
